<template>
  <div class="modal-wrap">
    <div class="modal-header">
      <p class="mb-15 bold">Ändra Prio - {{ customers }}</p>
    </div>
    <div class="modal-content">

      <div class="flex flex-column">
        <label class="flex align-middle mb-15" v-for="(prio, index) in defaultPriorityGroups" :key="index">
          <input type="radio" class="mr-10" v-model="prioLevel" name="prio" v-bind:value="prio.id">
          <span class="prio-icon flex-inline mr-5" v-bind:class="prio.class"></span>{{ prio.alias }}
        </label>
        <label class="flex align-middle mb-15">
          <input type="radio" class="mr-10" v-model="prioLevel" name="prio" v-bind:value="0">
          <span class="prio-icon icon-prio-reset mr-5"></span>Nollställ
        </label>
        <label class="flex align-middle mb-10">
          <input type="radio" class="mr-10" v-model="prioLevel" name="prio" v-bind:value="666">
          <span class="prio-icon icon-prio-filled-red mr-5"></span>Inaktivera
        </label>
        <!-- async await @emil -->
        <div class="mt-5 ml-25" v-show="newPrioLevel === 666">
          <label class="switch mr-10">
            <input type="checkbox" class="mr-5" v-model="removeFromBids">
            <div class="slider round"></div>
          </label>
          <span>Inaktivera även kunden i sms-listan</span>
        </div>
      </div>

    </div>

    <div class="modal-buttons">
      <div class="grid2col">
        <button class="width-100 fg-black" @click="abort">
          avbryt
        </button>
        <button class="width-100" @click="save">
          spara
        </button>
      </div>
    </div>
    <spinner v-show="loading"/>
  </div>
</template>

<script>
import spinner from '../spinner';
export default {
  name: 'customerEditPrio',
  data() {
    return {
      newPrioLevel: null,
      removeFromBids: false,
      loading: false
    };
  },
  computed: {
    customers() {
      let string = '';
      let len = this.$store.state.showing.customerEditPrio.stakeholders.length;
      this.$store.state.showing.customerEditPrio.stakeholders.forEach((stakeholder, index) => {
        string += stakeholder.firstname + ' ';
        string += stakeholder.lastname;
        if (index < len - 1) {
          string += ', ';
        }
      });
      return string;
    },
    defaultPriorityGroups: {
      get() {
        return this.$store.state.showing.currentListingWithActiveShowing.priorityOptions;
      },
    },
    prioLevel: {
      get() {
        return this.$store.state.showing.customerEditPrio.priority;
      },
      set(value) {
        this.newPrioLevel = value;
      },
    },
  },
  methods: {
    abort() {
      this.$root.modalOpen = false;
    },
    save() {
      let data = {
        id: this.$store.state.showing.customerEditPrio.id,
        priority: this.newPrioLevel,
        objectId: this.$route.params.id,
      };
      this.loading = true;
      if (this.newPrioLevel !== 666) { // not inactivating this group
        this.$root.callFasAdApi('/internalapi/stakeholder-group/edit-priority/', 'POST', data).then((data) => {
          this.$store.dispatch('showing/storeShowingDataForSelectedListing', {listingId: this.$route.params.id});
          this.$root.handleResponseMessage(data);
          this.$root.modalOpen = false;
          this.loading = false;
        }).catch(console.error);
      } else {
        // inactivating group
        let deleteStakeholderGroupData = {
          id: this.$store.state.showing.customerEditPrio.id,
          objectId: this.$route.params.id,
        };

        let extraText = this.removeFromBids ? '\nKunden kommer även inaktiveras från sms-listan.' : '';
        let confirm = window.confirm('Vill du verkligen inaktivera kunden?' + extraText);
        if (!confirm) {
          return false;
        }
        this.$root.callFasAdApi('/internalapi/stakeholder-group/delete/', 'DELETE', deleteStakeholderGroupData).
            then((data) => {
              this.$store.dispatch('showing/storeShowingDataForSelectedListing', {listingId: this.$route.params.id});
              this.$root.handleResponseMessage(data);
              this.$root.modalOpen = false;
            }).
            catch(console.error);

        if (this.removeFromBids) {
          let removeFromBidNotificationsStakeholderGroup = {
            objectId: this.$route.params.id,
            stakeholderGroupId: this.$store.state.showing.customerEditPrio.id,
          };

          this.$root.callFasAdApi('/internalapi/bid/add-receiver-exception-to-stakeholder-group/', 'POST',
              removeFromBidNotificationsStakeholderGroup).then((data) => {
            console.log(data);
          }).catch(console.error);
        }

      }
    },
  },
  components: {
    spinner,
  },
};
</script>
